import Vue from 'vue'
import Vuetify, {
  VTextField,
  VCombobox,
  VAutocomplete,
  VTextarea,
  VCheckbox,
  VSimpleCheckbox,
  VAvatar,
  VRadio,
  VRadioGroup
} from 'vuetify/lib'
import ripple from 'vuetify/lib/directives/ripple'
import '@mdi/font/css/materialdesignicons.css'
import {
  cornflowerblue,
  lightgreen,
  darkgray,
  darkslategray,
  lavendergray,
  lightseagreen,
  sandybrown,
  skyblue,
  lightblue,
  slategray,
  tomato
} from './colors'

const opts = {
  theme: {
    themes: {
      light: {
        primary: cornflowerblue,
        secondary: skyblue,
        accent: lightseagreen,
        error: tomato,
        warning: sandybrown,
        info: cornflowerblue,
        success: lightseagreen,
        anchor: cornflowerblue,

        // Custom colours
        cornflowerblue,
        lightgreen,
        darkbg: darkslategray,
        darkgray,
        darkslategray,
        lavendergray,
        lightseagreen,
        sandybrown,
        skyblue,
        lightblue,
        slategray,
        tomato
      }
    },
    options: {
      customProperties: true,
      variations: false
    }
  }
}

Vue.use(Vuetify, {
  components: {
    VTextField,
    VCombobox,
    VAutocomplete,
    VTextarea,
    VCheckbox,
    VSimpleCheckbox,
    VAvatar,
    VRadio,
    VRadioGroup
  },
  directives: {
    ripple
  }
})

export default new Vuetify(opts)
